import { getToken, logout } from './authApi';

/**
 * Drop-in replacement for `fetch` that injects the Authorization header
 * and redirects to login on 401.
 */
export async function authFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
    const token = getToken();
    const headers = new Headers(init.headers);
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }

    const response = await fetch(input, { ...init, headers });

    if (response.status === 401) {
        logout();
        // logout() reloads the page, but return anyway to satisfy TypeScript
        return response;
    }

    return response;
}

/** Extract a readable message from a FastAPI error response body. */
export function apiErrorMessage(errorBody: unknown, fallback: string): string {
    if (!errorBody || typeof errorBody !== 'object') return fallback;
    const detail = (errorBody as { detail?: unknown }).detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (Array.isArray(detail)) {
        const parts = detail
            .map((item) => {
                if (typeof item === 'string') return item;
                if (item && typeof item === 'object' && 'msg' in item) {
                    return String((item as { msg: unknown }).msg);
                }
                return null;
            })
            .filter(Boolean);
        if (parts.length) return parts.join('; ');
    }
    return fallback;
}
